import { render, staticRenderFns } from "./addHszn.vue?vue&type=template&id=297951bd"
import script from "./addHszn.vue?vue&type=script&lang=js"
export * from "./addHszn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports